import { LitElement, html } from 'lit';
import { t } from '../i18n';
import type { SearchBoxActionDetail } from './shared';
import { defineZenComponent } from './register';

export class ZenSearchBox extends LitElement {
  static properties = {
    active: { attribute: false },
    query: { attribute: false },
  };

  declare active: boolean;
  declare query: string;

  constructor() {
    super();
    this.active = false;
    this.query = '';
  }

  createRenderRoot() {
    return this;
  }

  updated(changed: Map<string, unknown>) {
    if (changed.has('active') && this.active) {
      this.querySelector<HTMLInputElement>('#searchInput')?.focus();
    }
  }

  private emit(action: SearchBoxActionDetail['action'], query = '') {
    this.dispatchEvent(new CustomEvent<SearchBoxActionDetail>('search-box-action', {
      bubbles: true,
      composed: true,
      detail: { action, query },
    }));
  }

  render() {
    return html`
      <button class="header-icon-btn" id="searchToggleBtn" title=${t('search')}>
        <span class="mi">search</span>
      </button>
      <div class="header-search-box ${this.active ? 'searching' : ''}" id="headerSearchBox">
        <span class="mi mi-sm search-bar-icon">search</span>
        <input
          type="text"
          id="searchInput"
          .value=${this.query}
          placeholder=${t('searchPlaceholder')}
          autocomplete="off"
          @input=${(event: Event) => this.emit('query-change', (event.target as HTMLInputElement).value)}
        >
        <button class="header-icon-btn" @click=${() => this.emit('clear-search')}>
          <span class="mi mi-sm">close</span>
        </button>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', (event) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest('#searchToggleBtn')) this.emit('toggle-search');
    });
  }
}

defineZenComponent('zen-search-box', ZenSearchBox);
